<template>
  <div class="index-load-state text-xs-center pa-5">
    <v-progress-circular
      v-if="loading"
      indeterminate
      size="40"
      width="3"
      color="grey"
    ></v-progress-circular>
    <v-alert
      v-else-if="error"
      :value="true"
      type="error"
      outline
      class="ma-0 text-xs-left"
    >
      {{ error }}
    </v-alert>
    <div v-else class="grey--text">{{ emptyText }}</div>
  </div>
</template>

<script>
export default {
  name: 'IndexLoadState',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    emptyText: {
      type: String,
      default: 'No records found.'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/general/IndexLoadState.vue